import React, { useState } from "react";
import Proptypes from "prop-types";
import Popover, { ArrowContainer } from "react-tiny-popover";

import Icon from "../../Icon";

const Checkbox = ({ id, label, bool, setBool, infoMessage }) => {
  const [showInfo, setShowInfo] = useState(false);

  const Info = ({ position, targetRect, popoverRect }) => {
    return (
      <ArrowContainer
        position={position}
        targetRect={targetRect}
        popoverRect={popoverRect}
        arrowColor={"#404040"}
      >
        <p className="Tooltip-text" role="alert" aria-live="polite">
          {infoMessage}
        </p>
      </ArrowContainer>
    );
  };

  return (
    <div className="ListingFilters-checkboxWrapper">
      <div className="ListingFilters-check">
        <input
          id={id}
          type="checkbox"
          value="open"
          defaultChecked={bool}
          onChange={(event) => setBool(event.target.checked)}
        />
        <label htmlFor={id}>{label}</label>
      </div>

      <Popover
        isOpen={showInfo}
        position={["bottom", "top"]}
        onClickOutside={() => setShowInfo(false)}
        content={({ position, targetRect, popoverRect }) => (
          <Info
            position={position}
            targetRect={targetRect}
            popoverRect={popoverRect}
          />
        )}
      >
        <button
          type="button"
          className="btn-reset"
          onClick={() => setShowInfo(!showInfo)}
        >
          <Icon
            name="infoCircle"
            className="ListingFilters-icon"
            width="20"
            height="20"
          />
          <span className="u-screenreader">What does {label} mean?</span>
        </button>
      </Popover>
    </div>
  );
};

Checkbox.propTypes = {
  id: Proptypes.string.isRequired,
  label: Proptypes.string.isRequired,
  bool: Proptypes.bool.isRequired,
  setBool: Proptypes.func.isRequired,
  infoMessage: Proptypes.string,
};

export default Checkbox;
